import React from 'react';
import { withStyles} from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import ReportCardsGroupTile from './ReportCardsGroupTile';

const styles = theme => ({
  entry: {
    marginTop: 20,
    marginBottom: 20,
  },
});

class ReportCardsGroupTiles extends React.Component {
  render() {
    const {
      classes,
      entries,
      onEntryClick,
    } = this.props;

    return (
      <div className="report-cards-group-tiles">
        {entries.map((entry) => {
          return (
            <div
              key={entry.id}
              className={classes.entry}
            >
              <ReportCardsGroupTile
                data={entry}
                dateFormat={dateFormat}
                onDetailsButtonClick={onEntryClick}
                useSuspense={false}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(ReportCardsGroupTiles));
